import React, { Component } from 'react';
import { Grid } from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';
import DayPicker, { DateUtils } from 'react-day-picker';
import 'react-day-picker/lib/style.css';
import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { namespaces } from '../../../constants/translation';

moment.locale('en-gb');
class InputCalendarRange extends Component {
  static propTypes = {
    dateFrom: PropTypes.string,
    dateTo: PropTypes.string,
    filterNameFrom: PropTypes.string.isRequired,
    filterNameTo: PropTypes.string.isRequired,
    onSetRange: PropTypes.func.isRequired,
    onReset: PropTypes.func.isRequired,
    t: PropTypes.func,
  }
  constructor(props) {
    super(props);
    this.state = {
      showOverlay: false,
      showOverlayRight: false,
      value: '',
      from: this.props.dateFrom ? new Date(this.props.dateFrom) : null,
      to: this.props.dateTo ? new Date(this.props.dateTo) : null,
    };
  }
  componentWillUnmount() {
    clearTimeout(this.clickTimeout);
  }

  inputFrom = null;
  inputTo = null;
  clickedInside = false;
  clickTimeout = null;

  handleContainerMouseDown = () => {
    this.clickedInside = true;
    // The input's onBlur method is called from a queue right after onMouseDown event.
    // setTimeout adds another callback in the queue, but is called later than onBlur event
    this.clickTimeout = setTimeout(() => {
      this.clickedInside = false;
    }, 0);
  }
  handleInputFromFocus = () => {
    if (this.state.showOverlayRight) {
      this.setState({
        showOverlayRight: false,
        showOverlay: true,
      }, () => {
        this.inputFrom.focus();
      });
    } else {
      this.setState({
        showOverlay: true,
      });
    }
  }
  handleInputToFocus = () => {
    if (!this.state.from) {
      this.setState({
        showOverlayRight: false,
        showOverlay: true,
      }, () => {
        this.inputFrom.focus();
      });
    } else {
      this.setState({
        showOverlayRight: true,
        showOverlay: false,
      }, () => {
        this.inputTo.focus();
      });
    }
  }
  handleInputFromBlur = () => {
    const showOverlay = this.clickedInside;
    this.setState({
      showOverlay,
    });
    // Force input's focus if blur event was caused by clicking on the calendar
    if (showOverlay && !this.state.from) {
      this.inputFrom.focus();
    }
  }
  handleInputToBlur = () => {
    const showOverlayRight = this.clickedInside;
    if (!this.state.showOverlay) {
      this.setState({
        showOverlayRight,
      });
    }
  }
  handleDayClick = (day) => {
    const range = DateUtils.addDayToRange(day, this.state);
    this.setState(range, () => {
      if (this.state.from && !this.state.to) {
        this.inputTo.focus();
        this.setState({
          showOverlay: false,
          showOverlayRight: true,
        }, () => {
          this.props.onSetRange(moment(this.state.from).format('YYYY-MM-DD'), '');
        });
      } else if (this.state.from && this.state.to) {
        this.setState({
          showOverlay: false,
          showOverlayRight: false,
        }, () => {
          if (this.state.showOverlayRight) {
            this.inputTo.blur();
          }
          this.props.onSetRange(moment(this.state.from).format('YYYY-MM-DD'), moment(this.state.to).format('YYYY-MM-DD'));
        });
      }
    });
  }
  handleReset = () => {
    this.setState({
      from: null,
      to: null,
      showOverlay: false,
      showOverlayRight: false,
    }, () => {
      this.inputFrom.blur();
      this.inputTo.blur();
      if (this.props.onReset) {
        this.props.onReset(this.props.filterNameFrom, this.props.filterNameTo);
      }
    });
  }
  render() {
    const overlayStyle = {
      position: 'absolute',
      background: 'white',
      boxShadow: '0 2px 5px rgba(0, 0, 0, .15)',
      zIndex: '9999',
    };
    const overlayStyleRight = {
      position: 'absolute',
      background: 'white',
      boxShadow: '0 2px 5px rgba(0, 0, 0, .15)',
      zIndex: '9999',
      right: '0',
    };
    const { from, to, showOverlay, showOverlayRight } = this.state;
    const { t } = this.props;
    return (
      <Grid><Grid.Row onMouseDown={this.handleContainerMouseDown}>
        <Grid.Column width={8} style={{ paddingRight: '0.5rem' }}>
          <div className="ui fluid icon input">
            <input
              type="text"
              ref={(el) => { this.inputFrom = el; }}
              placeholder={t('Start date')}
              value={from ? moment(from).format('L') : ''}
              onFocus={this.handleInputFromFocus}
              onBlur={this.handleInputFromBlur}
              readOnly
            />
            <i aria-hidden="true" className="calendar icon" />
          </div>
          { showOverlay &&
            <div style={{ position: 'relative' }}>
              <div style={overlayStyle}>
                <DayPicker
                  numberOfMonths={1}
                  selectedDays={[from, { from, to }]}
                  onDayClick={this.handleDayClick}
                />
              </div>
            </div>
          }
        </Grid.Column>
        <Grid.Column width={8} style={{ paddingLeft: '0.5rem' }}>
          <div className="ui fluid icon input">
            <input
              type="text"
              ref={(el) => { this.inputTo = el; }}
              placeholder={t('End date')}
              value={to ? moment(to).format('L') : ''}
              onFocus={this.handleInputToFocus}
              onBlur={this.handleInputToBlur}
              readOnly
            />
            <i aria-hidden="true" className="calendar icon" />
          </div>
          { showOverlayRight &&
            <div style={{ position: 'relative' }}>
              <div style={overlayStyleRight}>
                <DayPicker
                  numberOfMonths={1}
                  selectedDays={[from, { from, to }]}
                  onDayClick={this.handleDayClick}
                />
              </div>
            </div>
          }
        </Grid.Column>
      </Grid.Row></Grid>
    );
  }
}

export default withTranslation(namespaces, { withRef: true })(InputCalendarRange);



// WEBPACK FOOTER //
// ./src/components/Filters/BookingDatePicker/InputCalendarRange.jsx